// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `thead.table-border{top:0 !important}.text-center{text-align:center}`, "",{"version":3,"sources":["webpack://./src/components/location-webex/location-webex.scss"],"names":[],"mappings":"AAAA,mBACE,gBAAA,CAGF,aACE,iBAAA","sourcesContent":["thead.table-border {\n  top: 0 !important;\n}\n\n.text-center {\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
